export default __webpack_public_path__ + "static/media/sass-logo.8351205a.svg";